export const ADD_PRODUCT_TEXT = 'Add Product'
export const ADD_MS_ONLY_TEXT = 'Add MasterSpec options only'
export const ADD_MS_AND_MFR_TEXT = 'Add MasterSpec and Manufacturer options'
export const SELECT_TEXT = 'Select'
export const CANCEL_TEXT = 'Cancel'
export const CONTINUE_TEXT = 'Continue'
export const CAUTION_TEXT = 'Caution'

export const MSONLY_INSTRUCTION_TEXT =
    'Select this option to add available MasterSpec property options to your project.'
export const MS_MFR_INSTRUCTION_TEXT =
    'Select this option to add both available MasterSpec options and additional Manufacturer options to your project.'
export const MS_MFR_INSTRUCTION_SUB_TEXT =
    "Adding Manufacturer options may introduce proprietary aspects to the product you are adding. Additional research may be required for bidding purposes.To learn more about the product, reach out to the contact located on the cards' resources tab"

export const WARNING_TEXT = 'Warning'

export const ADD_PROJECT_MANUFACTURER_WARNING_TEXT = `You have selected a Manufacturer Product Type to add to your project.\n
This product type was added by one or more manufacturers and not the MasterSpec
content team. Adding a Manufacturer Product Type will make available products with
Manufacturer Options.\n
These options may introduce proprietary aspects to your project. Additional research 
may be required for bidding purposes.`

export const REMOVE_MO_TEXT = `The product you have selected to add to the project does not
have Manufacturer Options on its properties. Other products
that have been added from this Product Type have
Manufacturer Options. \n \n If you add this product, all products with Manufacturer
Options will be removed from the project. Do you want to
continue?`

export const REMOVE_MS_TEXT = `The product you have selected to add to the project has
Manufacturer Options on its properties. None of the other
products that have been added from this Product Type have
Manufacturer Options. \n\n If you add this product, all products without Manufacturer
Options will be removed from the project. Do you want to
continue?`

export const versionControlBarMarginOM = 145
export const smmWorkspaceElementsPanelMargin = 65
export const aeWorkspaceElementsPanelMargin = 110

export const PT_ACTIVATION_DIALOG_WIDTH = 700
export const PT_ACTIVATION_DIALOG_HEIGHT = 233
export const PT_ACTIVATION_DIALOG_MAX_WIDTH = 650

export const PRODUCT_TYPE_ACTIVATION_REVIEWER_MESSAGE =
    'Product type activation is restricted to Admins and Authors. As a Contributor, you can only interact with product types that have already been added to the project.'

export const PRODUCT_TYPE_ACTIVATION_ADMIN_AUTHOR_MESSAGE =
    'The activate and inactivate actions are unavailable for product types. Use the elements tree to add or remove product types.'

export const PRODUCT_TYPE_ACTIVATION_OM_MESSAGE =
    'Product Types must be activated or inactivated in the Elements tree.'

export const UNKNOWN_PRODUCT_NAME = 'Unknown Product Name'
export const NO_PRODUCT_NAME = 'No Product Name'

export const OM_DEACTIVATED_NODE_TOOLTIP =
    'This content is inactive in the Office Master'

export const PT_GROUP_DIALOG_TITLE = 'Action Not Allowed'

export const PT_GROUP_DEACTIVATE_MESSAGE = (isArticleLevel: boolean): string => {
    const noun = isArticleLevel ? 'article' : 'paragraph'
    return `This ${noun} contains one or more Product Types and cannot be deactivated directly. Use the elements tree to remove all Product Types and inactivate any non-Product Type paragraphs to inactivate this ${noun}.`
}

export const PT_GROUP_ACTIVATE_MESSAGE = (isArticleLevel: boolean): string => {
    const noun = isArticleLevel ? 'article' : 'paragraph'
    return `This ${noun} is inactive because its Product Type and paragraphs are inactive. Use the elements tree to activate one Product Type, or activate a non-Product Type paragraph, to activate this ${noun}.`
}

export const PT_PARA_DEACTIVATE_MESSAGE = (nodeName: string): string =>
    `"${nodeName}" is a Product Type paragraph and cannot be deactivated directly. Use the elements tree to remove the Product Type.`

export const PT_PARA_ACTIVATE_MESSAGE = (nodeName: string): string =>
    `"${nodeName}" is a Product Type paragraph and cannot be activated directly. Use the elements tree to activate the Product Type.`
export const PT_CHILD_PARA_DEACTIVATE_HEADER_MESSAGE = `Unable to Activate/Inactivate Product Type`
